import { Component } from '@angular/core';
import { LineDashArrayViewComponent } from '../../line-type-item/line-dash-array-view.component';

@Component({
  selector: 'app-traffic-legend',
  templateUrl: './traffic-legend.component.html',
  styleUrls: ['./traffic-legend.component.scss'],
  imports: [LineDashArrayViewComponent],
})
export class TrafficLegendComponent {}
